import { MapPin, Navigation, Plane, Route } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { usePageMeta, PageHero, FinalCTA, Eyebrow } from "../components/Shared";
import { SERVICE_AREAS, COMPANY, IMAGES } from "../data/site";

const MAP_SRC =
  "https://www.google.com/maps?q=1750+Britannia+Rd+E,+Mississauga,+ON+L4W+1J3&output=embed";

export default function ServiceArea() {
  usePageMeta("Service Area", "CoreDock Logistics is based in Mississauga and serves Brampton, Toronto, Etobicoke, Vaughan, Oakville, Milton, Burlington, Hamilton, the GTA and the Toronto–Montreal freight corridor.");
  return (
    <>
      <PageHero eyebrow="Coverage" image={IMAGES.boxTruck}
        title="Mississauga at the Centre. Ontario in Reach."
        subtitle="Local pickup and delivery across the Greater Toronto Area, with dedicated support for the Toronto–Montreal freight corridor." />

      <section className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid lg:grid-cols-2 gap-12">
          <Reveal>
            <div className="border-4 border-navy overflow-hidden h-[420px]">
              <iframe title="CoreDock Logistics location" src={MAP_SRC} className="w-full h-full border-0"
                      loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="service-map" />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <Eyebrow>Our Base</Eyebrow>
            <h2 className="font-display font-bold tracking-tight text-3xl md:text-4xl mt-3">{COMPANY.address}</h2>
            <p className="text-text-secondary mt-1">{COMPANY.city}</p>
            <div className="space-y-4 mt-8">
              {[
                { icon: Navigation, t: "Easy Highway 401 Access", d: "Fast connections across the GTA and beyond." },
                { icon: Plane, t: "Minutes from Pearson Airport", d: "Ideal for time-sensitive inbound and outbound freight." },
                { icon: Route, t: "Toronto–Montreal Corridor", d: "Coordinated support along the main freight lane." },
              ].map((x) => (
                <div key={x.t} className="flex gap-4 bg-white border border-border p-5">
                  <x.icon className="text-orange shrink-0" strokeWidth={1.5} />
                  <div>
                    <h3 className="font-display font-bold">{x.t}</h3>
                    <p className="text-sm text-text-secondary mt-1">{x.d}</p>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-navy text-white py-20 md:py-28">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <Reveal className="mb-12 max-w-2xl">
            <Eyebrow>Where We Deliver</Eyebrow>
            <h2 className="font-display font-bold tracking-tight text-3xl md:text-5xl mt-3">
              Pickup &amp; delivery across the GTA
            </h2>
          </Reveal>
          <Stagger className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-px bg-white/10 border border-white/10">
            {[...SERVICE_AREAS, "& More Ontario"].map((a) => (
              <StaggerItem key={a} className="bg-navy p-6 flex items-center gap-3 hover:bg-navy-800 transition-colors">
                <MapPin size={18} className="text-orange shrink-0" />
                <span className="font-display font-semibold">{a}</span>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
